export enum TRANSACTION_TYPES {
  SERVICES_BOOKING = 'services_booking',
  RESOURCES_BOOKING = 'resources_booking',
  EVENT_POSTS = 'event_posts',
  ORDERING = 'ordering',
  MEMBERSHIP = 'membership',
}

export enum SupportedPaymentMethods {
  INVOICE = 'INVOICE',
  CREDIT_CARD = 'CREDIT_CARD',
  APPLE_PAY = 'APPLE_PAY',
  CREDIT_POINTS = 'CREDIT_POINTS',
}

export enum TransactionDetailsServiceTypes {
  APPOINTMENT = 'APPOINTMENT',
  CLASS = 'CLASS',
  EVENT = 'EVENT',
}

export enum PATCH_STATUSES_3DS {
  SUCCEEDED = 'succeeded',
  FAILED = 'failed',
}
